import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Typography, useMediaQuery } from '@material-ui/core'
import { loadUpcomingEventsManaged, resetUpcomingEventManaged } from 'state/modules/userAccounts'

import { EventContainer } from '../EventContainer'
import { SectionBlock } from '../SectionBlock'

import { useStyles } from './UpcomingEventManageByMeSection.style'

const STEP_NUMBER = 1

const UpcomingEventManageByMeSection = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const isDesktop = useMediaQuery((theme) => theme.breakpoints.up('md'))

  const {
    userAccount,
    upcomingEventsManaged,
    upcomingEventsManagedPageNumber,
    upcomingEventsManagedLastPage
  } = useSelector((state) => state.userAccounts)

  useEffect(() => {
    if (userAccount) dispatch(loadUpcomingEventsManaged(userAccount.id))

    return () => dispatch(resetUpcomingEventManaged())
  }, [userAccount.id, dispatch])

  const minForRepeat = isDesktop ? 4 : 1

  return (
    !!upcomingEventsManaged.length && (
      <SectionBlock
        sectionClassName={classes.expandedSection}
        title={!isDesktop && 'Próximos eventos de org. administradas por mí'}>
        <div className={classes.mainContainer}>
          {isDesktop && (
            <Typography className={classes.title} color='primary' variant='h6'>
              Próximos eventos de organizaciones administradas por mí
            </Typography>
          )}
          <EventContainer
            events={upcomingEventsManaged}
            autoplay={true}
            nextPage={upcomingEventsManagedPageNumber + STEP_NUMBER}
            lastPage={upcomingEventsManagedLastPage}
            infinite={upcomingEventsManaged.length > minForRepeat}
            fetchNewPage={(page) => dispatch(loadUpcomingEventsManaged(userAccount.id, page))}
          />
        </div>
      </SectionBlock>
    )
  )
}

export default UpcomingEventManageByMeSection
